import "@/assets/scss/style.scss"
import "@/modules/components/short-video"
import "@/modules/components/video-progress"
import "@/modules/components/share-overlay"
import "@/modules/components/fullscreen"
import "@/modules/components/pip"
import "@/modules/components/lora/short-video"
import "@/modules/components/playlist/grid"
import "@/modules/components/playlist/carousel"
import "@/modules/components/playlist/storybook"
import "@/modules/components/cart-integration"
import { VERSION } from "@/version"
import Cookies from "js-cookie"
import GlobalSettings from "@/core/global-settings"
const helper = require("@/helpers/index.js")
import { LoraStreamAnalytics } from "@/core/lorastream-analytics"
import { MetaPixel } from "@/core/pixel"
let isRendered = false
let isPiPPlaying = false

function renderLogVersion() {
    const LINE_WIDTH = 60 // Fixed width for all lines
    const title = "WELCOME TO THE SHORT VIDEO"
    const versionMessage = `Current Version: ${VERSION}`

    const centerAlign = (content = "", width = LINE_WIDTH) => {
        const padding = Math.max(0, (width - content.length) / 2)
        return " ".repeat(Math.floor(padding)) + content + " ".repeat(Math.ceil(padding))
    }

    console.log(`
    ${"=".repeat(LINE_WIDTH)}
    ${centerAlign(`🌟 🚀         ${title}          🚀 🌟`)}
    ${"=".repeat(LINE_WIDTH)}
    ${centerAlign(versionMessage)}
    ${"=".repeat(LINE_WIDTH)}
    `)
}

renderLogVersion()

function executionBeforeRendering() {
    if (isRendered) return // Prevent double execution
    try {
        window.LoraStreamGoogleAnalytics = new LoraStreamAnalytics()
        updateDimensionBrowser()
        renderPiPIfHave()
        GlobalSettings.getScreenOrientation()
        GlobalSettings.getGlobalStyle()
        GlobalSettings.getDevice()
        GlobalSettings.getCountry()
        isRendered = true
    } catch (error) {
        console.error("ERROR LOADED", error) // Use console.error for errors
    }
}

if (document.readyState === "complete") {
    // If the document is already loaded, execute immediately.
    executionBeforeRendering()
} else {
    // Otherwise, wait for the load event.
    window.addEventListener("load", executionBeforeRendering)
}

window.addEventListener(
    "resize",
    helper.debounce(() => {
        updateDimensionBrowser()
        autoPlayVideoWhenScrolledToPlaylist()
        GlobalSettings.getScreenOrientation()
        GlobalSettings.getDevice()
    }, 300)
)

window.addEventListener("PIP_INFO", (event) => {
    const { isMuted, isPlaying } = event?.detail
    isPiPPlaying = isPlaying || false
})

if (window.screen.orientation)
    window.screen.orientation.addEventListener("change", function () {
        GlobalSettings.getScreenOrientation()
    })

document.addEventListener(
    "scroll",
    helper.debounce(() => {
        autoPlayVideoWhenScrolledToPlaylist()
    }, 300)
)

function autoPlayVideoWhenScrolledToPlaylist() {
    const pipElement = document.querySelector("b-pip")
    if (pipElement) {
        const videoPipElement = pipElement?.shadowRoot.querySelector(".lora-pip__video")
        if (videoPipElement && !videoPipElement?.paused) {
            isPiPPlaying = true
        }
    }

    if (isPiPPlaying) {
        return
    }
    const loraPlaylists = ["carousel-playlist", "grid-playlist", "story-block-playlist"]
    let firstVideo = null
    let currentPlaylistComponent = null
    loraPlaylists.forEach((loraPlaylist) => {
        const loraPlaylistComponents = document.querySelectorAll(loraPlaylist)
        loraPlaylistComponents.forEach((loraPlaylistComponent) => {
            //will trigger when your element comes into viewport
            let playlistItems = loraPlaylistComponent.shadowRoot.querySelectorAll(".lora-playlist")
            playlistItems.forEach((playlistItem) => {
                const rect = playlistItem.getBoundingClientRect()
                let playlistItemTop = rect.top,
                    playlistItemHeight = playlistItem.offsetHeight,
                    windowHeight = window.innerHeight
                if (playlistItemTop > 0 && windowHeight >= playlistItemTop + playlistItemHeight) {
                    // Playlist in the current viewport
                    // Find the first video of playlist:
                    const firstVideoInPlaylist = playlistItem.querySelector("video-embed")
                    if (!firstVideo) {
                        firstVideo = firstVideoInPlaylist
                        currentPlaylistComponent = loraPlaylistComponent
                    } else {
                        const rectFirstVideoInPlaylist = firstVideoInPlaylist.getBoundingClientRect()
                        let itemTop = rectFirstVideoInPlaylist.top
                        const rectFirstVideoItem = firstVideo.getBoundingClientRect()
                        let firstItemTop = rectFirstVideoItem.top
                        if (firstItemTop > itemTop) {
                            firstVideo = firstVideoInPlaylist
                            currentPlaylistComponent = loraPlaylistComponent
                        }
                    }
                }
            })
        })
    })
    if (!firstVideo) {
        return
    }
    const bShortVideo = firstVideo.shadowRoot.querySelector("b-short-video")
    if (!bShortVideo) {
        return
    }
    const loraComponents = ["video-embed", "carousel-playlist", "grid-playlist", "story-block-playlist"]
    const firstVideoElement = bShortVideo.shadowRoot.querySelector("video")
    let hasVideoPlaying = false
    loraComponents.forEach((loraComponent) => {
        const loraVideoComponents = document.querySelectorAll(loraComponent)
        loraVideoComponents.forEach((loraVideo) => {
            if (loraVideo !== currentPlaylistComponent) {
                helper.selectAllVideosInShadowDOM(loraVideo, "", (videoElement) => {
                    if (videoElement !== firstVideoElement) {
                        videoElement.pause()
                    }
                })
            } else {
                helper.selectAllVideosInShadowDOM(loraVideo, "", (videoElement) => {
                    if (!videoElement.paused && videoElement !== firstVideoElement) {
                        hasVideoPlaying = true
                    }
                })
            }
        })
    })
    if (!hasVideoPlaying && !isPiPPlaying) {
        firstVideoElement.play()
        firstVideo.setAttribute("autoplay", "")
    }
}

function updateDimensionBrowser() {
    var vh = window.innerHeight * 0.01
    var vw = window.innerWidth * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
    document.documentElement.style.setProperty("--vw", `${vw}px`)
}

function createPipPlayer(
    src,
    duration,
    durationString,
    playlistId,
    videoId,
    organizationId,
    current,
    loop,
    type,
    playingTime,
    audioState,
    pipStyle
) {
    const el = document.createElement("b-pip")
    el.setAttribute("src", src)
    el.setAttribute("duration", duration)
    el.setAttribute("duration-video-time", durationString)
    el.setAttribute("playing-time", playingTime)
    el.setAttribute("organization-id", organizationId)
    el.setAttribute("color-primary", "#acacac")
    el.setAttribute("size", "0% 100%")
    el.setAttribute("muted", audioState)
    el.setAttribute("pip-style", pipStyle)
    if (playlistId) {
        el.setAttribute("playlist-id", playlistId)
        el.setAttribute("current", parseInt(current))
        el.setAttribute("loop", loop)
        el.setAttribute("playlist-type", type)
    }
    if (videoId) {
        el.setAttribute("video-id", videoId)
    }
    document.body.appendChild(el)
}

function checkPiP() {
    let pipSrc = Cookies.get("lora-embed-pip")
    let pipDuration = Cookies.get("lora-embed-pip--duration")
    let pipDurationString = Cookies.get("lora-embed-pip--duration-string")
    let playlistId = Cookies.get("lora-embed-pip--playlist-id")
    let loop = Cookies.get("lora-embed-pip--loop")
    let current = Cookies.get("lora-embed-pip--current")
    let videoId = Cookies.get("lora-embed-pip--video-id")
    let organizationId = Cookies.get("lora-embed-pip--organization-id")
    let type = Cookies.get("lora-embed-pip--playlist-type")
    let playingTime = Cookies.get("lora-embed-pip--playing-time")
    let audioState = Cookies.get("lora-embed-pip--audio")
    let pipStyle = Cookies.get("lora-embed-pip--position")
    if (pipSrc && pipDuration && pipDurationString) {
        createPipPlayer(
            pipSrc,
            pipDuration,
            pipDurationString,
            playlistId,
            videoId,
            organizationId,
            current,
            loop,
            type,
            playingTime,
            audioState,
            pipStyle
        )
    } else {
        Cookies.remove("lora-embed-pip")
        Cookies.remove("lora-embed-pip--duration")
        Cookies.remove("lora-embed-pip--duration-string")
        Cookies.remove("lora-embed-pip--playlist-id")
        Cookies.remove("lora-embed-pip--video-id")
        Cookies.remove("lora-embed-pip--current")
        Cookies.remove("lora-embed-pip--loop")
        Cookies.remove("lora-embed-pip--organization-id")
        Cookies.remove("lora-embed-pip--playlist-type")
        Cookies.remove("lora-embed-pip--audio")
        Cookies.remove("lora-embed-pip--position")
    }
}

function getQueryString() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    })
    return params
}

function checkToPlayVideoInFs() {
    let params = getQueryString()
    let playlistId = params.playlistId
    let loop = params.loop !== null && params.loop !== "false" ? true : false
    let videoId = params.videoId
    let current = params.current ? parseInt(params.current) : 0
    if (playlistId || videoId) {
        const el = document.createElement("b-fullscreen")
        if (playlistId) {
            el.setAttribute("playlist-id", playlistId)
            el.setAttribute("current-index", current)
            el.setAttribute("loop", loop ? "true" : "false")
        }
        el.setAttribute("video-id", videoId)
        const url = new URL(window.location.href)
        url.searchParams.delete("playlistId")
        url.searchParams.delete("current")
        url.searchParams.delete("loop")
        window.history.replaceState({}, "", url)
        document.body.appendChild(el)
    } else {
        // Check has PIP:
        checkPiP()
    }
}

function renderPiPIfHave() {
    // Check play video in FS
    if (GlobalSettings.isLoaded) {
        checkToPlayVideoInFs()
    } else {
        setTimeout(async () => {
            await renderPiPIfHave()
        }, 100)
    }
}

export { LoraStreamAnalytics, MetaPixel }
